if (!customElements.get('pacu-interstitial-observer')) {
    customElements.define('pacu-interstitial-observer', class extends HTMLElement {
      constructor() {
        super();
        this.elements = this.querySelectorAll('.pacu-anim-up');
        
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            console.log(entry);
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '-80px 0px -80px 0px',
          threshold: 0
        });

        this.elements.forEach(el => this.observer.observe(el));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }





  if (!customElements.get('pacu-cta-observer')) {
    customElements.define('pacu-cta-observer', class extends HTMLElement {
      constructor() {
        super();
        this.elements = this.querySelectorAll('.pacu-anim-up');
        
        
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '-80px 0px -80px 0px',
          threshold: 0
        });

        this.elements.forEach(el => this.observer.observe(el));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }


  if (!customElements.get('pacu-ethos-observer')) {
    customElements.define('pacu-ethos-observer', class extends HTMLElement {
      constructor() {
        super();
        this.elements = this.querySelectorAll('.pacu-animate-up');
        
        
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target); // once: true
            }
          });
        }, {
          rootMargin: '-100px 0px -100px 0px',
          threshold: 0
        });

        this.elements.forEach(el => this.observer.observe(el));
      }

      disconnectedCallback() {
        this.observer.disconnect();
      }
    });
  }


  if (!customElements.get('pacu-products-observer')) {
    customElements.define('pacu-products-observer', class extends HTMLElement {
      constructor() {
        super();
        this.cards = this.querySelectorAll('.pacu-product-card');
        
        
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '-100px 0px -100px 0px',
          threshold: 0
        });

        this.cards.forEach(card => this.observer.observe(card));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }


    if (!customElements.get('pacu-film-product')) {
    customElements.define('pacu-film-product', class extends HTMLElement {
      constructor() {
        super();
        this.initObserver();
        this.initLightbox();
      }

      initObserver() {
        const elements = this.querySelectorAll('.pacu-anim');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '-80px 0px -80px 0px',
          threshold: 0
        });

        elements.forEach(el => observer.observe(el));
      }

      initLightbox() {
        this.trigger = this.querySelector('[data-lightbox-trigger]');
        this.overlay = this.querySelector('[data-lightbox-overlay]');
        this.closeBtn = this.querySelector('[data-lightbox-close]');
        this.img = this.overlay?.querySelector('.pacu-lightbox-img');

        if (!this.trigger || !this.overlay) return;

        // Open Lightbox
        this.trigger.addEventListener('click', () => {
          this.overlay.classList.add('is-open');
          document.body.style.overflow = 'hidden'; // Lock scroll
        });

        // Close Lightbox (Clicking overlay or button)
        const closeLightbox = () => {
          this.overlay.classList.remove('is-open');
          document.body.style.overflow = '';
        };

        this.overlay.addEventListener('click', closeLightbox);
        this.closeBtn?.addEventListener('click', closeLightbox);

        // Prevent closing when clicking the image itself
        this.img?.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }
    });
  }






   if (!customElements.get('pacu-ritual-observer')) {
    customElements.define('pacu-ritual-observer', class extends HTMLElement {
      constructor() {
        super();
        this.elements = this.querySelectorAll('.pacu-anim-up');
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '-80px 0px -80px 0px',
          threshold: 0
        });

        this.elements.forEach(el => this.observer.observe(el));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }